import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { EventEmiterService } from '../../../../../src/app/shared/services/event-emiter.service';
import { Router } from '@angular/router';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { ExpensaDto, GridPageSettings, LocalStorageKeys, MenuFuncionCodes } from '../../../../../src/app/shared/model';
import { ExpensaService, MenuFuncionService } from '../../../../../src/app/shared/services';

@Component({
  selector: 'app-expensasUf',
  templateUrl: './expensasUf.component.html',
  styleUrls: ['./expensasUf.component.scss']
})

export class ExpensasUfComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;

  isValidating: boolean = false;
  isSearching: boolean = false;
  canView: boolean = false;
  canViewDetalle: boolean = false;

  formGroup: FormGroup;

  public data: DataManager;
  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  private subscription: Subscription;

  constructor(
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private service: ExpensaService,
    private menuService: MenuFuncionService,
    private eventEmitterService: EventEmiterService
  ) {
    this.subscription = this.eventEmitterService.reloadView$.subscribe((value) => {
      this.loadView()
    });
   }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.DASHBOARD_EXPENSA_UF).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        this.canView = true;

        this.menuService.checkMenu(MenuFuncionCodes.EXPENSA_LIST).subscribe(data => {
          if (data != null && data.Success && data?.Result)
            this.canViewDetalle = true;

          this.loadView();
        },
        (err: HttpErrorResponse) => {
          this.sharedFunctions.handleError(err);
          this.loadView();
        });
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };


    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getDashboardMisExpensasUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    setTimeout(() => {
      if (this.grid?.getRows()?.length > 0)
        this.grid?.autoFitColumns()
    }, 1000);
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    var index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = cId;
    else
      this.query.addParams("ConsorcioId", cId);
  }

  getTraduccion(value: string) {
    return this.sharedFunctions.getNombreMenuTenant(value);
  }

  onGridActionFailure(event: any): void {
    // this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
    console.error(event);
  }

  loadDashboard() {
    this.grid.refresh();
    setTimeout(() => {
      if (this.grid?.getRows()?.length > 0)
        this.grid?.autoFitColumns()
    }, 1000);
  }

  view(item: ExpensaDto) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['expensa-edit', item.Id]);
  }

  viewAll() {
    if (!this.canViewDetalle) {
      this.sharedFunctions.showMessage("No tiene permisos para llevar a cabo la operación", "Error");
      return false;
    }

    this.router.navigate(['expensa-list']);
  }
}
